/**
 * Три портала на поддомене клуба (moyklub.baysport.ru):
 * — /           клиенты (личный кабинет)
 * — /staff      тренеры
 * — /manage     администраторы
 */
import { normalizeRole } from "./roles";

export const PORTALS = {
  patient: {
    id: "patient",
    title: "Личный кабинет клиента",
    subtitle: "Для спортсменов и родителей",
    home: "/",
    login: "/login",
    register: "/register",
    app: "/app",
    role: "client",
    accent: "patient",
  },
  staff: {
    id: "staff",
    title: "Кабинет тренера",
    subtitle: "Для тренеров",
    home: "/staff",
    login: "/staff/login",
    register: null,
    app: "/staff/app",
    role: "trainer",
    accent: "staff",
  },
  admin: {
    id: "admin",
    title: "Управление клубом",
    subtitle: "Для администраторов",
    home: "/manage",
    login: "/manage/login",
    register: null,
    app: "/manage/app",
    role: "admin",
    accent: "admin",
  },
};

export function detectPortalFromPath(pathname = "") {
  if (pathname.startsWith("/staff")) return PORTALS.staff;
  if (pathname.startsWith("/manage")) return PORTALS.admin;
  return PORTALS.patient;
}

export function getPortalByRole(role) {
  const r = normalizeRole(role);
  if (r === "admin" || r === "owner") return PORTALS.admin;
  if (r === "trainer") return PORTALS.staff;
  if (r === "client") return PORTALS.patient;
  return PORTALS.patient;
}
